export enum UserRequestTypeEnum {
	API = "API",
	CLIENT = "Client",
	AUTH = "Auth"
}